import Router from 'vue-router'
import {routerattr} from './index1.js'


export default new Router({
    routes: routerattr
})


// WEBPACK FOOTER //
// ./src/router/index.js